import { createRootRoute, createRoute, createRouter, Outlet, redirect } from '@tanstack/react-router';
import { currentAccount } from './auth';
import { Callback } from './routes/Callback';
import { Home } from './routes/Home';
import { Kit } from './routes/Kit';
import { ShellDemo } from './routes/ShellDemo';
import { Login, type LoginSearch } from './routes/Login';
import { NotFound } from './routes/NotFound';
import { AskHanaPage } from '@hana/zone-box';
import { zoneRoutes } from './zones';

const rootRoute = createRootRoute({ component: Outlet, notFoundComponent: NotFound });

// ?ret=<vùng> : mở một vùng khi chưa đăng nhập thì về đây, đăng nhập xong quay lại đúng vùng (QĐ 24/Oct 16:26).
const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  validateSearch: (s: Record<string, unknown>): LoginSearch => ({
    ...(typeof s.ret === 'string' ? { ret: s.ret } : {}),
    ...(s.err === 'notcompany' || s.err === 'failed' ? { err: s.err } : {}),
  }),
  beforeLoad: async ({ search }) => {
    // đã đăng nhập → vào thẳng lưới vùng
    if (!search.err && (await currentAccount())) throw redirect({ to: '/home' });
  },
  component: Login,
});

const callbackRoute = createRoute({ getParentRoute: () => rootRoute, path: '/auth/callback', component: Callback });

const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/home',
  beforeLoad: async () => {
    if (!(await currentAccount())) throw redirect({ to: '/', search: {} });
  },
  component: Home,
});

// Ask HANA toàn trang: ngoài khung ERP (có rail riêng), mở từ nút cú ở mọi vùng (issue 334).
const askRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/ask',
  beforeLoad: async () => {
    if (!(await currentAccount())) throw redirect({ to: '/', search: { ret: 'ask' } });
  },
  component: AskHanaPage,
});
// /ui-kit — trang mẫu thành phần (Hybrid-Kit), không cần đăng nhập, không có dữ liệu thật. (/kit nay là vùng HANA Kit — QĐ 01/Nov.)
const kitRoute = createRoute({ getParentRoute: () => rootRoute, path: '/ui-kit', component: Kit });
const shellDemoRoute = createRoute({ getParentRoute: () => rootRoute, path: '/ui-kit/shell/$', component: ShellDemo });

export const router = createRouter({ routeTree: rootRoute.addChildren([loginRoute, callbackRoute, homeRoute, askRoute, kitRoute, shellDemoRoute, ...zoneRoutes(rootRoute)]) });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
